export enum OfferType {
  J2F = 'J2F',
  P2C = 'P2C',
  P2S = 'P2S',
  J2F_S = 'J2F_S',
  CONTINUE = 'CONTINUE',
  GIVE_UP = 'GIVE_UP',
}
